import { buildRows } from "../../lib/script"
import classes from './MockRows.module.css'

export default function MockRows({numberOfRows}) {
    let cells = buildRows(numberOfRows)
    return <tr>
        {cells && cells.map(item => (
            <td key={item.id} className={classes.row_cell}></td>
        ))}
    </tr>
}